module.exports = __webpack_public_path__ + "img/20190529105636微信截图_20190529110032.f4ad320f.png";